/** Match backend ALLOWED_CURRENCY_CODES order: SEK/EUR/USD/GBP, then A–Ö (JPY shown as YEN in SV). */
export const CURRENCY_CODES_ORDERED = [
  "SEK",
  "EUR",
  "USD",
  "GBP",
  "AUD",
  "CAD",
  "CHF",
  "CNY",
  "DKK",
  "HKD",
  "MXN",
  "NOK",
  "SGD",
  "JPY",
];

/** Short labels for selects (JPY → YEN per product copy). */
export function currencySelectLabel(code, lang) {
  if (code === "JPY" && lang === "sv") return "YEN (JPY)";
  return code;
}

export function formatCurrencyAmount(amount, currencyCode, lang = "sv") {
  const code = currencyCode || "SEK";
  const locale = lang === "en" ? "en-GB" : "sv-SE";
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: code,
      maximumFractionDigits: 2,
    }).format(Number(amount) || 0);
  } catch {
    return `${Number(amount) || 0} ${code}`;
  }
}
